(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cuvara-prelaunch"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.Shopify?.designMode) return;
  const form = document.querySelector('.cv-form');
  if (!form || form.dataset.cuvaraTrackingReady) return;
  form.dataset.cuvaraTrackingReady = 'true';
  const key = 'cuvara:launch-pending:' + form.id;
  const allowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return privacy?.marketingAllowed?.() === true &&
      privacy?.analyticsProcessingAllowed?.() === true &&
      privacy?.saleOfDataAllowed?.() === true;
  };
  form.addEventListener('submit', () => {
    try {
      sessionStorage.removeItem(key);
      if (!allowed() || !form.checkValidity()) { return; }
      sessionStorage.setItem(key, JSON.stringify({
        id: 'cuvara-' + crypto.randomUUID(),
        createdAt: Date.now()
      }));
    } catch (_) { }
  });
  let busy = false;
  let sent = false;
  const publishSuccess = async () => {
    if (busy || sent || !form.querySelector('.cv-success') || !allowed()) return;
    const analytics = window.Shopify?.analytics;
    if (typeof analytics?.publish !== 'function') { return; }
    busy = true;
    try {
      const pending = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!pending) { return; }
      if (typeof pending.id !== 'string' || !pending.id.startsWith('cuvara-') ||
          !Number.isFinite(pending.createdAt) || Date.now() - pending.createdAt > 3600000 ||
          pending.createdAt > Date.now()) {
        sessionStorage.removeItem(key);
        return;
      }
      const accepted = await analytics.publish('cuvara:launch_signup_success', {
        submission_id: pending.id,
        form_name: 'cuvara_launch'
      });
      if (accepted !== false) {
        sent = true;
        sessionStorage.removeItem(key);
      }
    } catch (_) { } finally { busy = false; }
  };
  const initializePrivacy = () => {
    if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}],
        error => { if (!error) publishSuccess(); });
    }
  };
  initializePrivacy();
  publishSuccess();
  document.addEventListener('visitorConsentCollected', publishSuccess);
  let attempts = 0;
  const timer = setInterval(() => {
    publishSuccess();
    if (sent || ++attempts >= 40) clearInterval(timer);
  }, 500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
